import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'

import { MsStoresLoadingProps } from '../StoreReturnsSettings'
import { StoreSuppliesSettings, SuppliesFormData } from '../StoreSuppliesSettings'
import { useApi } from '../../../hooks/storeHook'

import { OzonAccountProps } from '../../../types/accountProps'
import { OzonDeliveryType } from '../../../server/mpsklad_core/Entity/Ozon/OzonDeliveryType'

export type OzonSuppliesSettingsProps =
  OzonAccountProps & MsStoresLoadingProps

export const OzonSuppliesSettings =
  observer(
    ({account, msStores, loadMsStores}: OzonSuppliesSettingsProps) => {
      const [selectedStatus, setSelectedStatus] = useState(account.autoCreateMoveDocsInMoySkladOnSupplyStatus)

      const api = useApi()

      const onSubmit =
        async ({autoCreateMoveDocsInMoySklad, supplyMoveSourceStoreId, supplyMoveTargetStoreId}: SuppliesFormData) => {
          await api.userSync.setOzonSuppliesSettings({
            accountId: account.id,
            autoCreateMoveDocsInMoySkladOnSupplyStatus: selectedStatus,
            autoCreateMoveDocsInMoySklad,
            supplyMoveSourceStoreId,
            supplyMoveTargetStoreId
          })
        }

      return (
        <StoreSuppliesSettings
          account={account}
          msStores={msStores}
          loadMsStores={loadMsStores}
          deliveryTypeHint="FBO"
          autoMoveHint="по поставкам Ozon"
          isAllowed={account.allowOptionAutoCreateMoveDocsInMoySklad && account.deliveryType === OzonDeliveryType.FBO}
          selectedStatus={selectedStatus}
          setSelectedStatus={setSelectedStatus}
          onSubmit={onSubmit}
        />
      )
    })